var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({staticClass:"type-button ordinary",class:[_vm.converse ? 'converse' : ''],attrs:{"round":""}},'el-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",[_vm._v(_vm._s(this.type))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6a5c5e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ByButton.vue
// module id = null
// module chunks = 